<ng-container *ngIf="!wasUndone; else undone">
  <p class="ti-headline" data-test="result-headline">
    <strong>{{ written }}</strong>
    {{ written === 1 ? 'row went in' : 'rows went in' }}
    <span class="br-text-muted">
      ({{ result.created }} added, {{ result.updated }} updated)
    </span>
  </p>
</ng-container>

<ng-template #undone>
  <p class="ti-headline" data-test="result-headline">
    The import has been undone.
    <span class="br-text-muted" *ngIf="result.failed">
      {{ result.failed }}
      {{ result.failed === 1 ? 'record was' : 'records were' }}
      left alone — see below.
    </span>
  </p>
</ng-template>

<!-- Shown when there is a list OR when there is a count with no list behind
     it. The second is the case worth the most: a screen that hides itself
     because the list came back empty is a screen that says nothing at all
     about rows the summary just counted as lost. -->
<section *ngIf="notImportedCount || unlistedFailures" class="ti-section">
  <div class="ti-not-imported-head">
    <h3 class="ti-section-title">
      {{ wasUndone ? 'Not put back' : 'Did not go in' }}
      <span class="br-text-muted br-small">{{ notImportedCount }}</span>
    </h3>
    <!-- A button, not a link. A link is a navigation, a navigation has no
         bearer token, and this one is built here anyway. -->
    <button type="button" class="br-btn br-btn--sm br-btn--outline"
            *ngIf="notImportedCount"
            (click)="downloadNotImported()" data-test="download-not-imported">
      Download these rows
    </button>
  </div>

  <!-- A count with no rows behind it is worse than either mistake alone: the
       file reads as complete and is taken away as complete. -->
  <div class="br-alert br-alert--danger br-mb-2" *ngIf="unlistedFailures"
       data-test="unlisted-failures">
    {{ unlistedFailures }} more
    {{ unlistedFailures === 1 ? 'row was' : 'rows were' }}
    counted as failing to write than are listed here, so this list — and the
    file it downloads — is not the whole of what did not go in.
  </div>

  <!-- Kept apart on purpose. One group is rows we refused before trying, the
       other is rows we said would go in and then did not, and a person does
       something different about each. -->
  <ng-container *ngIf="unwritten.length">
    <h4 class="ti-kind-title" data-test="unwritten">
      We said these would go in
      <span class="br-text-muted br-small">{{ unwrittenCount }}</span>
    </h4>
    <ng-container
      *ngTemplateOutlet="groups; context: { list: unwritten }"></ng-container>
  </ng-container>

  <ng-container *ngIf="refused.length">
    <h4 class="ti-kind-title" *ngIf="unwritten.length" data-test="refused">
      Refused before we tried
      <span class="br-text-muted br-small">{{ refusedCount }}</span>
    </h4>
    <ng-container
      *ngTemplateOutlet="groups; context: { list: refused }"></ng-container>
  </ng-container>
</section>

<ng-template #groups let-list="list">
  <div *ngFor="let group of list" class="ti-group"
       [attr.data-reason]="group.reason">
    <h4 class="ti-group-title">
      {{ group.copy.title }}
      <span class="br-text-muted br-small">{{ group.rows.length }}</span>
    </h4>
    <p class="br-text-muted br-small ti-group-say">{{ group.copy.sentence }}</p>
    <ul class="ti-rows">
      <li *ngFor="let row of group.rows" class="ti-row"
          [attr.data-row]="row.rowNo">
        <span class="ti-row-no">{{ row.rowNo }}</span>
        <span class="ti-row-id">{{ identify(row) }}</span>
        <span class="ti-row-say br-text-muted">
          <span *ngIf="row.detail">{{ row.detail }}</span>
          <span *ngFor="let note of notesOn(row)" class="ti-note">
            {{ noteCopy(note).sentence }}
          </span>
        </span>
      </li>
    </ul>
  </div>
</ng-template>

<div class="ti-undo" *ngIf="result.canUndo || undoing">
  <button type="button" class="br-btn br-btn--sm br-btn--outline"
          [disabled]="!canUndo" (click)="undoRequested.emit()"
          data-test="undo-import">
    {{ undoing ? 'Undoing…' : 'Undo this import' }}
  </button>
  <span class="br-text-muted br-small">
    Puts back what this run changed. A record somebody has edited since is
    left as it now stands.
  </span>
</div>
